import { DeliveryStateType } from '../../types/models'

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const DeliveryReducer = (_: any, action: any): DeliveryStateType => {
  return action.payload
}
